module.exports = __webpack_public_path__ + "media/icons/switch_green@3x-f6517d53.svg";